var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchReservationsTablePlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6918_277245)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#709FAF",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6918_277245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 18.5C33 16.57 28.52 15 23 15C17.48 15 13 16.57 13 18.5C13 20.31 16.95 21.81 22 21.98V26H20.35C19.53 26 18.8 26.5 18.49 27.26L17 31H19L20.2 28H25.8L27 31H29L27.5 27.26C27.2 26.5 26.46 26 25.65 26H24V21.98C29.05 21.81 33 20.31 33 18.5ZM23 17C27.05 17 29.74 17.86 30.72 18.5C29.74 19.14 27.05 20 23 20C18.95 20 16.26 19.14 15.28 18.5C16.26 17.86 18.95 17 23 17Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6918_277245",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6918_277245"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6918_277245",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6918_277245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchReservationsTablePlan);
export default __webpack_public_path__ + "static/media/switch_reservations_table_plan.6b7d6fdf1a3357692bd6563272749967.svg";
export { ForwardRef as ReactComponent };